
import { fork, take, call, put } from 'redux-saga/effects'

import * as types from '../types'
import * as actions from '../actions'

import { isBtUser } from '@/network'
import Toast from '@/components/comToast'
export function* recIsBai() {
    while (true) {
        yield take(types.REC_ISBAI);
        try {
            const v = yield call(isBtUser)
            if(v && v.resultCode === '0000') {
                yield put(actions.handleIsBai(v.value));
            }
        } catch (e) {
            if(e?.error) {
                Toast.showMessage('活动太火爆了');
            }
        } finally {
        }

    }
}

export default function* root() {
    yield fork(recIsBai)
}